<template>
    <div class="content-area">
        <swb-deal-inqry-voucher-info :id="id" :showFlag=false ref="swb_deal_inqry_voucher_info"></swb-deal-inqry-voucher-info>

        <div class="examine-item">
            <div class="examine-content" style="padding-left: 0;">
                <div class="form-info">
                    <div class="form-row" style="line-height: 90px;">
                        <div class="form-label" style="width: auto">
                            <label class="font-bold">申请描述</label>
                        </div>
                        <div class="form-value">
                            <textarea class="width-2x" placeholder="申请描述" v-model="applyDesc"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import dealApi from '../../api/deal'

    import SwbDealInqryVoucherInfo from './DealInqryVoucherInfo';
    Vue.regist(SwbDealInqryVoucherInfo);

    export default{
        name: 'swb-deal-inqry-voucher-apply',
        desc: '询盘申请',
        props: ['id'],
        data: function () {
            return {
                dealInqryVoucher: {},
                applyDesc: null,
            }
        },
        created: function () {
            let self = this;
            self.getDealInqryVoucherById();
        },
        methods: {
            getDealInqryVoucherById: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let lastMsgBoxDlg = MsgBox.loading();
                dealApi.getDealInqryVoucher(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        self.dealInqryVoucher = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let self = this;
                self.dealInqryVoucher.applyDesc = self.applyDesc;
                let result = {};
                result.data = self.dealInqryVoucher;
                result.type = "info";
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/InqryVoucher/DealInqryVoucherApply.vue